import { AnyAction } from "redux";
import { TeamInterface } from "../types";

export const requested = (state: TeamInterface): TeamInterface => ({
  ...state,
  requestStates: {
    ...state.requestStates,
    statistics: { failed: false, requesting: true, success: false },
  },
});

export const success = (
  state: TeamInterface,
  action: AnyAction
): TeamInterface => ({
  ...state,
  statistics: action.statistics,
  requestStates: {
    ...state.requestStates,
    statistics: { failed: false, requesting: false, success: true },
  },
});

export const failed = (
  state: TeamInterface,
  action: AnyAction
): TeamInterface => ({
  ...state,
  requestStates: {
    ...state.requestStates,
    statistics: {
      failed: action.error,
      requesting: false,
      success: false,
    },
  },
});

export const clear = (state: TeamInterface): TeamInterface => ({
  ...state,
  statistics: [],
  requestStates: {
    ...state.requestStates,
    statistics: {
      failed: false,
      requesting: false,
      success: false,
    },
  },
});
